import {
  JobOffersListPage,
  JobOffersListPageProps
} from 'features/job-offers/list';
import { OfferLanguage } from 'model';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ServiceCurrency, ServiceLanguage } from 'services';
import { DEFAULT_LOCALE } from 'services/multilingual.service';
import { ServiceTechRole } from 'services/service.tech-roles';
import { ServiceTechs } from 'services/service.techs';
import { config } from 'utils/config';
import { getLocale } from 'utils/localize.utils';

export default JobOffersListPage;

export const getStaticProps: GetStaticProps<JobOffersListPageProps> = async ({
  locale
}) => {
  const lang = getLocale(locale);

  const [currencies, techs, techRoles, allLanguages] = await Promise.all([
    // A fake token is used here since we need to access the real API endpoint here, not the NextJS one, even though this endpoint is not authenticated
    ServiceCurrency.getAll(lang),
    ServiceTechs.getAllAsListItems(lang, 'fake-token'),
    ServiceTechRole.getAllAsListItems(lang, 'fake-token'),
    ServiceLanguage.getAllAsListItems(lang, 'fake-token')
  ]);

  const languages: OfferLanguage[] = [
    {
      code: 'ES',
      id: 1,
      name: {
        ES: 'Español',
        EN: 'Spanish'
      },
      showInOffer: true
    },

    {
      code: 'EN',
      id: 2,
      name: {
        ES: 'Inglés',
        EN: 'English'
      },
      showInOffer: true
    }
  ];

  return {
    revalidate: 30,
    props: {
      currencies,
      languages,
      techs,
      techRoles,
      allLanguages,
      baseUrl: config.appUrl,
      ...(await serverSideTranslations(locale || DEFAULT_LOCALE, [
        'common',
        'job-offer-list',
        'offer-alert-modal',
        'topbar',
        'footer',
        'job-offer-url-non-exist-modal'
      ]))
    }
  };
};
